<!--template html-->
<template>
    <div v-if="card" class="carousel-page">
        <div v-if="displayPageNames" class="mt-card-cover-header d-flex justify-content-between align-items-center">
            <p class="mb-0">Cover</p>
            <ul class="mt-card-cover-action hidden">
                <li class="">
                    <a href="#">
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                            <path fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M0.553223 6.24346C0.553223 5.43073 1.2107 4.77187 2.02481 4.77187H10.8418C11.6545 4.77187 12.3134 5.42935 12.3134 6.24346V15.0604C12.3134 15.8732 11.6559 16.532 10.8418 16.532H2.02481C1.21207 16.532 0.553223 15.8746 0.553223 15.0604V6.24346ZM2.02324 6.24189H10.8434V15.062H2.02324V6.24189ZM7.16831 7.71191H5.69829V9.91694H3.49326V11.387H5.69829V13.592H7.16831V11.387H9.37334V9.91694H7.16831V7.71191ZM15.2534 12.122C16.0653 12.122 16.7234 11.4622 16.7234 10.652V9.18193H15.2534V10.652H13.7834V12.122H15.2534ZM16.7234 1.83184C16.7234 1.01997 16.0636 0.361816 15.2534 0.361816H13.7834V1.83184H15.2534V3.30186H16.7234V1.83184ZM6.4333 0.361816C5.62143 0.361816 4.96328 1.02162 4.96328 1.83184V3.30186H6.4333V1.83184H7.90332V0.361816H6.4333ZM9.37334 0.361816H12.3134V1.83184H9.37334V0.361816ZM15.2534 4.77187H16.7234V7.71191H15.2534V4.77187Z"
                                  fill="#1E2437" />
                        </svg>
                    </a>
                </li>
                <li class="">
                    <a href="#">
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
                            <path d="M10.3036 6.57124L10.0137 14.4866L11.1866 14.5295L11.4765 6.6142L10.3036 6.57124Z" fill="#1E2437" />
                            <path d="M8.82854 6.59253H7.65479V14.5075H8.82854V6.59253Z" fill="#1E2437" />
                            <path d="M6.18075 6.57154L5.00781 6.6145L5.29772 14.5298L6.47065 14.4869L6.18075 6.57154Z" fill="#1E2437" />
                            <path d="M11.5251 3.21207V3.11293V1.62591C11.5251 1.05092 11.0572 0.583008 10.4822 0.583008H6.00135C5.42637 0.583008 4.95845 1.05092 4.95845 1.62591V3.11095V3.21008H4.85932H0.182129V4.38384H1.51252H1.60372L1.61165 4.47505L2.74576 17.3566C2.77352 17.662 3.02334 17.892 3.33065 17.892H13.1351C13.4424 17.892 13.6922 17.662 13.72 17.3566L14.8541 4.47505L14.862 4.38384H14.9532H16.3054V3.21008H11.6243H11.5251V3.21207ZM6.13221 3.11293V1.8559V1.75677H6.23134H10.2542H10.3534V1.8559V3.11293V3.21207H10.2542H6.23134H6.13221V3.11293ZM13.6803 4.38384L13.6704 4.49091L12.6018 16.627L12.5938 16.7182H12.5026H3.9552H3.864L3.85607 16.627L2.7874 4.49091L2.77748 4.38384H2.88653H13.5693H13.6803Z"
                                  fill="#1E2437" />
                        </svg>
                    </a>
                </li>
            </ul>
        </div>
        <GroupCardCover :collection="this.collection" :cover="card.CoverPage" :defaultScale="defaultScale" :pageHeight="pageHeight" :editable="false" :showTitlePlaceholder="showTitlePlaceholder"/>
        <!--GroupCardCover component -->
    </div>
    <!--Group card cover page -->

    <div v-if="card" class="carousel-page page_template_1">
        <div v-if="displayPageNames" class="mt-card-cover-header d-flex justify-content-between align-items-center">
            <p class="mb-0 page-number"></p>
        </div>
        <div class="gc-booklet" :class="pageClass">
            <div class="gc-booklet-inner page-height-gc-page" :style="'height:'+ pageHeight + 'px;'">
                <div class="gc-container">
                    <div class="gc-container-inner page-scale-gc-page" :style="'-webkit-transform: scale(' + defaultScale + ')'">
                        <div class="gc-column-inner">


                        </div>
                        <!--gc-column-inner-->
                    </div>
                    <!--gc-container-inner-->
                </div>
                <!--gc-container-->
            </div>
            <!--gc-booklet-inner-->
        </div>
    </div>
    <!-- Group card page(s) -->

    <div v-if="card" id="group-card-content-1" class="gc-message-visibility">
        <GroupCardMessageRawV2 @update-parent="updateLoaded" v-if="card.Messages" v-for="(message, index) in card.Messages" :message="message" :index="index" :key="index" :idKey="childKey" :columnType="card.CoverPage.ContentType" />
        <!-- GroupCardMessage component -->
    </div>
    <!-- Group card message(s) temporary to determine size -->

    <div v-if="card" class="carousel-page gc-back-cover-pg">
        <div class="gc-booklet gc-column-1">
            <div class="gc-booklet-inner page-height-gc-page" :style="'height:'+ pageHeight + 'px;'">
                <div class="gc-container">
                    <div class="gc-container-inner page-scale-gc-page" :style="'-webkit-transform: scale(' + defaultScale + ')'">
                        <div class="gc-column-inner">
                            <div class="gc-last-page">
                                <p v-if="card">
                                    View your card and messages online: <br />
                                    {{card.CoverPage.CardUrl}}
                                </p>
                                <div class="gc-last-page-footer">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="32" height="32" data-v-29585604=""><path fill="#7fe2dc" d="M 16 32 C 24.8366 32 32 24.8366 32 16 C 32 7.16344 24.8366 0 16 0 C 7.16344 0 0 7.16344 0 16 C 0 24.8366 7.16344 32 16 32 Z" data-v-29585604=""></path><path stroke="white" stroke-width="3" d="M 5.86632 20.2676 C 6.88428 22.9342 10.37 26.9342 15.9997 26.9342 C 21.6293 26.9342 25.1856 22.9342 26.133 20.2676" data-v-29585604=""></path></svg>
                                    <h5>Created at GroupTogether.com</h5>
                                    <h6>CID: {{card.CoverPage.CollectionId}}</h6>
                                </div>
                            </div>
                            <!-- gc-last-page -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--Group card last page -->
</template>
<!--template html-->
<!--script -->
<script>
    import GroupCardCover from './GroupCardCover.vue'
    import GroupCardMessage from './GroupCardMessage.vue'
    import GroupCardMessageRawV2 from './GroupCardMessageRawV2.vue'

    export default {
        name: 'GroupCardView',
        components: {
            GroupCardCover,
            GroupCardMessage,
            GroupCardMessageRawV2
        },
        props: {
            collection: String,
            classNamesCover: Array,
            classNamesPages: Array,
            isActive: Boolean,
            displayPageNames: Boolean,
            refreshComponent: Number,
            defaultScale: Number,
            pageHeight: Number,
            messageId: String,
            showTitlePlaceholder: {
                type: Boolean,
                default: false,
            },
        },
        data: function () {
            return {
                card: null,
                pages: 1,
                groupCardPages: [],
                renderingComplete: false,
                columns: 0,
                pageClass: "gc-column-1",
                pageNumber: 1,
                startLastPage: false,
                endOfRecords: false
            }
        },
        mounted: function () {
            this.getModelData();
        },
        methods: {
            async getModelData() {
                let apiUrl = '/api/collectionservices/gcgetcard?collection=' + this.collection + '&privacy=FALSE'
                if (this.messageId)
                    apiUrl += '&messageId=' + this.messageId

                await fetch(apiUrl)
                    .then((res) => res.json())
                    .then((data) => {
                        this.card = data

                        //checking if there are no messages in the card then initialize cover only
                        if (this.card.Messages.length === 0) {
                            this.$nextTick(() => {
                                this.generateCardCarousel()
                            })
                        }
                    })
                    .catch(err => console.log(this.card))
            },
            updateLoaded(height, uniqueId) {
                var foundIndex = this.card.Messages.findIndex(x => x.UniqueId == uniqueId);
                this.card.Messages[foundIndex].Height = height

                //checking to activate the carousel
                var pendingObjects = this.card.Messages.filter(message => {
                    return (message.Height === 0)
                })

                //check height of the message to fit between columns
                if ($("#msg-" + this.childKey + "-" + uniqueId).height() > (this.pageHeight - 35)) {
                    //remove class so content can be split
                    $("#msg-" + this.childKey + "-" + uniqueId).removeClass("dontsplit")
                }

                //activate carousel if all components are loaded
                if (pendingObjects.length === 0) {
                    this.pageNumber++
                    this.initPages()
                }
            },
            initPages() {
                this.columns = this.card.CoverPage.ContentType
                //setting page class
                if (this.columns === 1) {
                    this.pageClass = 'gc-column-1'
                }
                else if (this.columns === 2) {
                    this.pageClass = 'gc-column-2'
                }
                else if (this.columns === 3) {
                    this.pageClass = 'gc-column-3'
                }
                this.$nextTick(() => {
                    this.generateCardCarousel()
                })
                return true;
            },
            generateCardCarousel() {
                if (!this.renderingComplete) {
                    if ($('#group-card-content-1').text().length > 0 && (!$('#group-card-content-1').is(':empty'))) {
                        //when we need to add a new page, use a jq object for a template
                        var $page = $(".page_template_1:first").clone().addClass("page-carousel")
                        $(".carousel-inner").append($page)
                        this.pages++
                        var that = this
                        //columnizer plugin
                        $('#group-card-content-1').columnize({
                            columns: that.columns,
                            target: ".page-carousel:last .gc-column-inner",
                            buildOnce: true,
                            overflow: {
                                height: (that.pageHeight - 35),
                                id: "#group-card-content-1",
                                doneFunc: function () {
                                    that.generateCardCarousel()
                                }
                            }
                        });
                    }
                    else {
                        //remove empty message boxes if any
                        $('.gc-column-content').filter(function () {
                            return $.trim($(this).text()) === ''
                        }).remove()
                        //remove template page
                        $(".page_template_1:first").remove()
                        //remove content page
                        $("#group-card-content-1").remove()
                        //move the card cover to last
                        $(".carousel-inner").append($(".gc-back-cover-pg"))
                        //complete rendering
                        this.renderingComplete = true
                        this.$emit('activate-carousel')
                    }
                }
            }
        },
        computed: {
            initCoverClasses() {
                let classToAdd = ""

                if (this.classNamesCover) {
                    for (let i = 0; i < this.classNamesCover.length; i++) {
                        classToAdd += this.classNamesCover[i] + " "
                    }
                }

                return classToAdd
            },
            initPageClasses() {
                let classToAdd = ""

                if (this.classNamesPages) {
                    for (let i = 0; i < this.classNamesPages.length; i++) {
                        classToAdd += this.classNamesPages[i] + " "
                    }
                }

                return classToAdd
            }
        },
        watch: {
            defaultScale(newVal, oldVal) {
                $(".page-height-gc-page").css("height", this.pageHeight + "px")
                $(".page-scale-gc-page").css("-webkit-transform", "scale(" + this.defaultScale + ")")
            }
        }
    }
</script>
<!--script -->
<!--Add "scoped" attribute to limit CSS to this component only-->
<style scoped>
    .gc-message-visibility {
        visibility: hidden;
    }
</style>
